export interface Character {
  id: string;
  name: string;
  title: string;
  role: "师兄" | "师姐" | "师弟" | "师妹" | "师尊" | "外门" | "对手";
  tags: string[];
  closeness: number;
  desc: string;
  portrait: string;
}

export const characters: Character[] = [
  {
    id: "lu-chenyuan",
    name: "陆沉渊",
    title: "云隐峰大师兄",
    role: "师兄",
    tags: ["沉稳内敛", "步步破境", "暖心担当"],
    closeness: 96,
    desc: "云隐峰大师兄，资质平平却靠苦修一步一个脚印。看似寡言，实则把同门冷暖都看在眼里，是全峰公认的「定海神针」。",
    portrait:
      "https://readdy.ai/api/search-image?query=Cultivation%20sect%20senior%20brother%20portrait%20in%20traditional%20Chinese%20ink%20wash%20illustration%2C%20gentle%20resolute%20young%20man%20in%20flowing%20grey-blue%20hanfu%2C%20warm%20vermilion%20and%20gold%20accents%2C%20ethereal%20mountain%20background%2C%20refined%20detail&width=600&height=800&seq=char-lu-01&orientation=portrait",
  },
  {
    id: "su-wanyue",
    name: "苏挽月",
    title: "云隐峰大师姐",
    role: "师姐",
    tags: ["御剑如虹", "雷厉风行", "刀子嘴豆腐心"],
    closeness: 92,
    desc: "大师姐苏挽月，一柄寒光剑出鞘惊天。嘴上总嫌弃师弟师妹拖后腿，真到危难时刻却总是第一个挡在前面。",
    portrait:
      "https://readdy.ai/api/search-image?query=Elegant%20cultivation%20sect%20senior%20sister%20portrait%20in%20Chinese%20ink%20wash%20style%2C%20sharp%20beautiful%20woman%20holding%20a%20cold%20glowing%20sword%2C%20flowing%20white%20and%20red%20hanfu%2C%20ethereal%20misty%20mountain%20setting%2C%20refined%20detail&width=600&height=800&seq=char-su-01&orientation=portrait",
  },
  {
    id: "shen-wujiu",
    name: "沈无咎",
    title: "云隐峰二师兄",
    role: "师兄",
    tags: ["话痨", "炼丹房常客", "气氛担当"],
    closeness: 84,
    desc: "二师兄沈无咎是峰里的话痨担当，也是炼丹房的常客。炸过炉、烧过药田，却总能在气氛冷下来时把大家逗笑。",
    portrait:
      "https://readdy.ai/api/search-image?query=Cheerful%20cultivation%20sect%20second%20senior%20brother%20portrait%20in%20Chinese%20ink%20wash%20illustration%2C%20jovial%20young%20man%20with%20messy%20hair%20in%20earthy%20hanfu%2C%20alchemy%20furnace%20glow%2C%20warm%20tones%2C%20refined%20detail&width=600&height=800&seq=char-shen-01&orientation=portrait",
  },
  {
    id: "lin-shuangchi",
    name: "林霜迟",
    title: "云隐峰三师姐",
    role: "师姐",
    tags: ["冷面", "护短", "暗器高手"],
    closeness: 78,
    desc: "三师姐林霜迟面冷话少，却最是护短。谁若敢欺负云隐峰的弟子，她的银针绝不会答应。",
    portrait:
      "https://readdy.ai/api/search-image?query=Cool%20composed%20cultivation%20sect%20senior%20sister%20portrait%20in%20Chinese%20ink%20wash%20painting%2C%20reserved%20woman%20in%20dark%20teal%20hanfu%20with%20silver%20needles%2C%20faint%20smile%2C%20misty%20mountain%20backdrop%2C%20refined%20detail&width=600&height=800&seq=char-lin-01&orientation=portrait",
  },
  {
    id: "wen-ruchun",
    name: "温如初",
    title: "云隐峰小师弟",
    role: "师弟",
    tags: ["呆萌", "资质极高", "团宠"],
    closeness: 88,
    desc: "小师弟温如初资质惊艳却一身呆气，常被师兄师姐们轮流「投喂」与「坑骗」。他认准的人，就一定会护到底。",
    portrait:
      "https://readdy.ai/api/search-image?query=Innocent%20junior%20cultivation%20disciple%20portrait%20in%20Chinese%20ink%20wash%20style%2C%20adorable%20young%20boy%20in%20pale%20yellow%20hanfu%2C%20curious%20wide%20eyes%2C%20warm%20golden%20tones%2C%20ethereal%20mountains%2C%20refined%20detail&width=600&height=800&seq=char-wen-01&orientation=portrait",
  },
  {
    id: "xuanzhenzi",
    name: "玄真子",
    title: "云隐峰掌门",
    role: "师尊",
    tags: ["威严", "护犊", "暗中布局"],
    closeness: 90,
    desc: "云隐峰掌门玄真子，看似威严古板，实则护犊子出了名。峰中大小事务，往往有他深藏不露的一步棋。",
    portrait:
      "https://readdy.ai/api/search-image?query=Wise%20cultivation%20sect%20master%20portrait%20in%20Chinese%20ink%20wash%20painting%2C%20elder%20in%20white%20and%20gold%20robes%20with%20long%20beard%2C%20calm%20authoritative%20presence%2C%20misty%20peaks%20behind%2C%20refined%20detail&width=600&height=800&seq=char-xuan-01&orientation=portrait",
  },
  {
    id: "yun-miao",
    name: "云渺",
    title: "外门师妹",
    role: "师妹",
    tags: ["暗线", "身世成谜", "执念"],
    closeness: 60,
    desc: "外门师妹云渺，来路成谜。她与云隐峰的交集处处藏着伏笔，同门情谊背后是说不清的因果。",
    portrait:
      "https://readdy.ai/api/search-image?query=Mysterious%20outer-sect%20junior%20disciple%20portrait%20in%20Chinese%20ink%20wash%20style%2C%20elusive%20young%20woman%20in%20lavender%20hanfu%20half%20hidden%20by%20mist%2C%20melancholic%20aura%2C%20cool%20ethereal%20tones%2C%20refined%20detail&width=600&height=800&seq=char-yun-01&orientation=portrait",
  },
  {
    id: "gu-changfeng",
    name: "顾长风",
    title: "对家魔修",
    role: "对手",
    tags: ["亦敌亦友", "纠葛", "人气反派"],
    closeness: 55,
    desc: "魔修顾长风，与云隐峰纠葛极深。他并非纯粹恶人，与师兄陆沉渊之间的亦敌亦友，是读者津津乐道的名场面制造机。",
    portrait:
      "https://readdy.ai/api/search-image?query=Charismatic%20rival%20cultivator%20portrait%20in%20Chinese%20ink%20wash%20illustration%2C%20roguish%20handsome%20man%20in%20black%20and%20crimson%20hanfu%2C%20dark%20energy%20wisps%2C%20dramatic%20lighting%2C%20refined%20detail&width=600&height=800&seq=char-gu-01&orientation=portrait",
  },
];